import styled, { createGlobalStyle, keyframes } from "styled-components";

interface ContainerProps {
  $bgImage: string;
}

export const GlobalStyle = createGlobalStyle`
  /* Zera margens e padding de todos os elementos e define box-sizing */
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Garante que html e body ocupem 100% da viewport e não tenham bordas */
  html, body, #root {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
`;

/* ====== animações ====== */
const auroraDrift = keyframes`
  0%   { transform: translate3d(0, 0, 0) scale(1); }
  50%  { transform: translate3d(40px, -30px, 0) scale(1.15); }
  100% { transform: translate3d(0, 0, 0) scale(1); }
`;

const auroraDrift2 = keyframes`
  0%   { transform: translate3d(0, 0, 0) scale(1.1); }
  50%  { transform: translate3d(-50px, 30px, 0) scale(1); }
  100% { transform: translate3d(0, 0, 0) scale(1.1); }
`;

const borderGlow = keyframes`
  0%   { opacity: 0.55; }
  50%  { opacity: 1; }
  100% { opacity: 0.55; }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const shimmer = keyframes`
  0%   { transform: translateX(-130%) skewX(-18deg); }
  60%, 100% { transform: translateX(230%) skewX(-18deg); }
`;

/*
  Container: mantém a imagem de fundo TOTALMENTE visível (sem overlay escuro
  que ofusque o wallpaper). As auroras são apenas brilhos sutis nos cantos.
*/
export const Container = styled.div<ContainerProps>`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: flex-start; /* form continua à esquerda */
  align-items: center;
  background-color: #04060f;
  background-image: url(${(props) => props.$bgImage});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  font-family: 'Outfit', 'Plus Jakarta Sans', 'Segoe UI', sans-serif;

  /* auroras coloridas sutis nos cantos — não ofuscam o wallpaper */
  &::before {
    content: '';
    position: absolute;
    width: 48vw;
    height: 48vw;
    top: -18vw;
    right: -12vw;
    background: radial-gradient(circle, rgba(43, 123, 255, 0.28), transparent 62%);
    filter: blur(40px);
    animation: ${auroraDrift} 16s ease-in-out infinite;
    pointer-events: none;
    z-index: 0;
  }

  &::after {
    content: '';
    position: absolute;
    width: 44vw;
    height: 44vw;
    bottom: -20vw;
    left: -14vw;
    background: radial-gradient(circle, rgba(34, 211, 238, 0.22), transparent 62%);
    filter: blur(40px);
    animation: ${auroraDrift2} 20s ease-in-out infinite;
    pointer-events: none;
    z-index: 0;
  }
`;

export const LoginForm = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-left: 300px; /* mesmo local de antes */
  margin-top: -100px;
  width: 400px;
  max-width: calc(100vw - 40px);
  padding: 44px 38px 38px;
  border-radius: 24px;
  background: linear-gradient(160deg, rgba(14, 26, 56, 0.72) 0%, rgba(8, 16, 38, 0.78) 100%);
  border: 1px solid rgba(43, 123, 255, 0.28);
  box-shadow:
    0 24px 70px rgba(2, 8, 28, 0.7),
    inset 0 1px 0 rgba(150, 200, 255, 0.12);
  backdrop-filter: blur(20px) saturate(140%);
  -webkit-backdrop-filter: blur(20px) saturate(140%);
  color: #dce8ff;
  animation: ${fadeUp} 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
  transition: transform 0.35s ease, box-shadow 0.35s ease;

  /* anel de glow neon animado em volta do card */
  &::before {
    content: '';
    position: absolute;
    inset: -1px;
    border-radius: inherit;
    padding: 1px;
    background: linear-gradient(135deg, #2b7bff, #22d3ee 40%, transparent 70%);
    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor;
    mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    mask-composite: exclude;
    animation: ${borderGlow} 4s ease-in-out infinite;
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow:
      0 30px 90px rgba(2, 8, 28, 0.8),
      0 0 30px rgba(43, 123, 255, 0.35),
      inset 0 1px 0 rgba(150, 200, 255, 0.16);
  }
`;

export const Title = styled.h2`
  text-align: center;
  margin-bottom: 20px;
`;

export const Input = styled.input`
  padding: 12px;
  margin-bottom: 16px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
  transition: 0.3s;

  &:focus {
    outline: none;
    border-color: rgba(0, 64, 133, 0.8);
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
  }
`;

export const InputPass = styled.input`
  padding: 12px;
  margin-bottom: 0;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
  transition: 0.3s;

  &:focus {
    outline: none;
    border-color: rgba(0, 64, 133, 0.8);
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
  }
`;

export const Button = styled.button`
  position: relative;
  margin-top: 6px;
  padding: 14px 24px;
  font-size: 15px;
  font-family: 'Outfit', sans-serif;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #ffffff;
  border: none;
  border-radius: 14px;
  background: linear-gradient(120deg, #2b7bff 0%, #3b82f6 45%, #22d3ee 120%);
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 10px 26px rgba(43, 123, 255, 0.45);
  transition: transform 0.2s ease, box-shadow 0.25s ease, filter 0.2s ease;

  /* brilho que varre o botão */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 45%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.45), transparent);
    transform: translateX(-130%) skewX(-18deg);
  }

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 14px 34px rgba(43, 123, 255, 0.6), 0 0 18px rgba(34, 211, 238, 0.4);
    filter: brightness(1.05);
  }

  &:hover:not(:disabled)::after {
    animation: ${shimmer} 1.1s ease;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
    box-shadow: none;
  }
`;

export const Logo = styled.img`
  display: block;
  max-width: 200px;
  margin: 0 auto;
  filter: drop-shadow(0 6px 18px rgba(0, 0, 0, 0.5));
  transition: all 0.3s ease;
`;

export const slideIn = keyframes`
  from {
    transform: translateX(40px);
    opacity: 0;
  }
  to {
    transform: translateX(0%);
    opacity: 1;
  }
`;

export const VerseText = styled.div`
  display: inline-block;
  animation: ${slideIn} 2.4s ease-out;
  white-space: nowrap;
`;

export const Footer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(20, 24, 40, 0.85) 0%, rgba(8, 10, 18, 0.95) 100%);
  border-top: 1px solid rgba(43, 123, 255, 0.3);
  backdrop-filter: blur(10px);
  color: #dce8ff;
  text-align: center;
  padding: 10px;
  font-size: 1.1rem;
  font-family: 'Plus Jakarta Sans', 'Segoe UI', sans-serif;
  letter-spacing: 0.2px;
  z-index: 999;
  overflow: hidden;
`;

/* =============== Animações do botão "Sobre mim" =============== */
const floatY = keyframes`
  0%   { transform: translateY(0); }
  50%  { transform: translateY(-6px); }
  100% { transform: translateY(0); }
`;

const pulseScale = keyframes`
  0%   { transform: scale(1); }
  50%  { transform: scale(1.04); }
  100% { transform: scale(1); }
`;

const ring = keyframes`
  0%   { opacity: .85; transform: scale(1); }
  70%  { opacity: 0.1;   transform: scale(1.6); }
  100% { opacity: 0;   transform: scale(1.8); }
`;

/* =============== Estilo do Botão "Sobre mim" =============== */
export const Aboutme = styled.button`
  position: absolute;
  bottom: 80px;
  right: 50px;
  z-index: 1000;

  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;

  background: rgba(12, 16, 32, 0.4);
  border: 1px solid rgba(43, 123, 255, 0.4);
  border-radius: 9999px;

  color: #e6f0ff;
  font-weight: 600;
  letter-spacing: 0.2px;
  cursor: pointer;

  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35), 0 0 0 4px rgba(43, 123, 255, 0.06);

  animation: ${floatY} 6s ease-in-out infinite,
    ${pulseScale} 2.8s ease-in-out infinite;

  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    border: 2px solid rgba(43, 123, 255, 0.35);
    animation: ${ring} 2.4s ease-out infinite;
    pointer-events: none;
  }

  &:hover {
    color: #7bb3ff;
    border-color: rgba(43, 123, 255, 0.65);
    background: rgba(20, 50, 110, 0.35);
  }

  &:active {
    transform: translateY(1px);
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    &::after {
      display: none;
    }
  }
`;
